export const NavBadge = ({ count, tone = 'red', testId, className = '' }) => {
  if (!count) return null;
  const bg = tone === 'blue' ? 'bg-blue-500' : 'bg-red-500';
  return (
    <span
      className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full text-white leading-none min-w-[16px] text-center ${bg} ${className}`}
      data-testid={testId}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};
